import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent } from './ui/dialog';
import ControlDetail from './ControlDetail';

// Fire this from anywhere to open the full control-detail view as an
// in-page modal (instead of navigating away). Mount <ControlDetailModalHost/>
// once on the page that needs it.
export const openControlDetail = (controlId) => {
  window.dispatchEvent(new CustomEvent('open-control-detail', { detail: { controlId } }));
};

const ControlDetailModalHost = () => {
  const [controlId, setControlId] = useState(null);

  useEffect(() => {
    const handler = (e) => { if (e.detail?.controlId) setControlId(e.detail.controlId); };
    window.addEventListener('open-control-detail', handler);
    return () => window.removeEventListener('open-control-detail', handler);
  }, []);

  return (
    <Dialog open={!!controlId} onOpenChange={(o) => { if (!o) setControlId(null); }}>
      <DialogContent
        className="max-w-[96vw] w-[96vw] h-[95vh] p-0 overflow-hidden translate-x-[-50%] translate-y-[-50%] sm:rounded-lg bg-appbg"
        data-testid="governance-control-detail-modal"
      >
        <div className="h-full overflow-y-auto bg-appbg">
          {controlId && (
            <ControlDetail
              controlId={controlId}
              isModal
              onClose={() => setControlId(null)}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ControlDetailModalHost;
